<template>
  <div class="Solicitudes" id="repairs">
    <card-wrapper
      id="repairs-card"
      :title="$t('title.repairs') || 'Reparaciones'"
      :hide-close-btn="true"
      :show-divider="true">
      <repairs-list></repairs-list>
    </card-wrapper>
  </div>
</template>

<script>
import CardWrapper from '@/components/general/CardWrapper.vue'
import RepairsList from '@/components/repairs/RepairsList'

export default {
  components: {
    RepairsList,
    CardWrapper,
  },
}
</script>
